import { Button, Icon } from "@chakra-ui/react";
import { t } from "i18next";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BidListItemForSupplierDto } from "../../../autogen/bff-api";
import { urls } from "../../../urls";

interface Props {
  bid: BidListItemForSupplierDto;
}

export const ViewEventButton = ({ bid }: Props) => {
  const navigate = useNavigate();

  const viewEvent = (bid: BidListItemForSupplierDto) => {
    navigate(urls.events.supplierView.go({ eventId: bid.forEvent.id, negotiationRoundId: bid.forNegotiationRoundId }));
  };

  return (
    <Button
      leftIcon={<Icon as={FaEye} w="15px" h="15px" />}
      variant={"solid"}
      colorScheme="teal"
      size={"sm"}
      onClick={() => {
        viewEvent(bid);
      }}
    >
      {t("View")}
    </Button>
  );
};
